module.exports = __webpack_public_path__ + "static/media/file-search.370d532a.svg";